import React, { createContext, useState, useCallback, useMemo } from "react";

export const ItemsContext = createContext();

export const ItemsProvider = ({ children }) => {
  const [items, _setItems] = useState(null);

  const setItems = useCallback((value) => {
    if (Array.isArray(value)) {
      _setItems(value);
    } else if (Array.isArray(value?.data)) {
      _setItems(value.data);
    } else {
      _setItems([]);
    }
  }, []);

  const contextValue = useMemo(() => ({ items, setItems }), [items, setItems]);

  return (
    <ItemsContext.Provider value={contextValue}>
      {children}
    </ItemsContext.Provider>
  );
};
